<template>
  <div class="editorial-list">
    <template v-for="content in props.content" :key="content.id">
      <!-- Text -->
      <template v-if="content.typeHandle === 'editorialContent'">
        <div class="row-1 m-top-3">
          <div
            class="text-l editorial-list__text editorial-list__basetext text-editorial"
            v-html="content.text"
          ></div>
        </div>
      </template>
      <!-- Title -->
      <template v-if="content.typeHandle === 'editorialContentBigTitle'">
        <div class="row-1 m-top-3 --title-row">
          <h2
            class="title editorial-list__title"
            v-anim-reveal-text
            v-html="content.text"
          ></h2>
        </div>
      </template>
      <!--  Gallery -->
      <template
        v-if="content.typeHandle === 'editorialContentFullScreenGallery'"
      >
        <EditorialFullGallery :content="content" class="m-top-3" />
      </template>
      <!-- Full Screen gallery -->
      <template v-if="content.typeHandle === 'editorialContentGallery'">
        <EditorialGallery :content="content" class="m-top-3" />
      </template>
      <!-- Full Screen video -->
      <template v-if="content.typeHandle === 'editorialContentVideo'">
        <div
          class="m-top-3"
          :class="{
            'row-1': !content.fullscreen.includes('si'),
          }"
          v-anim-parallax-element="{
            target: 'video',
          }"
        >
          <WidgetVideoIframe
            v-if="content.embed.includes('si')"
            class="ratio-full-screen"
            :videoUrl="
              content.video.replace(/\/view\?usp=sharing|\/view/, '/preview')
            "
          />
          <WidgetVideo
            v-else
            class="ratio-full-screen"
            :videoUrl="content.video"
            :autoplay="content.autoplay.includes('si')"
          />
        </div>
      </template>
      <!-- Full Screen videDouble column -->
      <template
        v-if="content.typeHandle === 'editorialContentDoubleColumnImages'"
      >
        <EditorialDoubleColumnImages :content="content" class="m-top-3" />
      </template>
      <!-- Full Screen videDouble column -->
      <template
        v-if="content.typeHandle === 'editorialContentDoubleColumnGeneral'"
      >
        <EditorialDoubleColumnGeneral :content="content" class="m-top-3" />
      </template>
      <!-- Free Content -->
      <template v-if="content.typeHandle === 'editorialContentFreeContent'">
        <div class="row-1 m-top-3">
          <div
            class="text-m editorial-list__text editorial-list__freecontent text-editorial"
            v-html="content.freeContent"
          ></div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'EditorialList',
}
</script>

<script setup>
const props = defineProps({
  content: Array,
})

onMounted(() => {
  // TACON CHE VA SEMPRE BENE PER SAFARI
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 500)
})
</script>

<style lang="scss">
@import './style.scss';
</style>
